import { useMobile } from "../../MobileContext";
import DesktopHeader from "../../components/DesktopHeader/DesktopHeader";
import styles from "../../styles/PageLayout.module.css";
import React from 'react';
import InquiriesDesktop from "../common/InquiriesDesktop";

const FinancialHome = () => {
    const isMobile = useMobile();

    return (
        <div className={styles.mainContainer}>
            {isMobile ? (
                <> </>
            ) : (
                <DesktopHeader
                    role={"financial-manager"}
                    showNotification={false}
                />
            )}
            <div className={styles.contentContainer}>
                <div className={styles.rightSectionContainer}>
                    {isMobile ? (
                        <> </>
                    ) : (
                        <InquiriesDesktop isNotificationPanelOpen={false} userRole={"financial-manager"}/>
                    )}
                </div>

            </div>
        </div>
    )
}

export default FinancialHome;